import React, { useState } from 'react';
import './Projects.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCards, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-cards';

const projectData = [
  {
    title: "Cry Recognition for Infant Behavior Assessment",
    description: "The Cry Recognition Device is a system that detects and analyzes a baby's cry to identify possible reasons such as hunger, discomfort, or pain. It uses a microphone to capture the baby's sounds and an AI-powered algorithm to classify different cry patterns. The results are then displayed on a mobile app, helping parents understand and respond to their baby's needs.",
    image: 'https://i.imgur.com/hWdF1Hs.png',
    mediaItems: [
      { type: 'image', url: 'https://i.imgur.com/IRNiQ0d.png' },
      { type: 'video', url: 'https://i.imgur.com/T2wQ3VN.mp4' },
      { type: 'video', url: 'https://i.imgur.com/T2wQ3VN.mp4' },
    ],
  },
  {
    title: 'Stardust Scribe',
    description: 'The Stardust Scribe, inspired by the brilliance of "Starry Night" offers an intuitive interface with features like dashboards, reminders, and friend feeds. It fosters easy navigation, growth, and community interaction, making your academic journey as captivating as the night sky.',
    image: 'https://i.imgur.com/AmkYznj.png',
    mediaItems: [
      { type: 'image', url: 'https://i.imgur.com/co4jzbf.png' },
      { type: 'image', url: 'https://i.imgur.com/eleuy3Q.png' },
      { type: 'image', url: 'https://i.imgur.com/KE4j3NX.png' },
    ],
  },
  {
    title: 'Database Management System for Rural Health Centers',
    description: 'It is a a system that is an accessible and secure database that will allow healthcare providers to easily manage and access patient records for newborns, pregnant women, and senior citizens in the community. ',
    image: 'https://i.imgur.com/CqyQ5Fw.png',
    mediaItems: [
      { type: 'image', url: 'https://i.imgur.com/P3W0K4S.png' },
      { type: 'image', url: 'https://i.imgur.com/HmKfq2t.png' },
      { type: 'image', url: 'https://i.imgur.com/Ap620Jp.png' },
      { type: 'image', url: 'https://i.imgur.com/o0Ca5FX.png' },
    ],
  },
  {
    title: 'PharmaSave',
    description: 'PharmaSave is a mobile application that helps users search for medicines and find nearby pharmacies that have them in stock, along with their prices. It aims to provide consumers with affordable alternatives by showing both branded and generic medicine options. The app’s main feature is its Nearby Pharmacy Map View, allowing users to locate the closest pharmacies offering their desired medicine.',
    image: 'https://i.imgur.com/oA9YIuj.png',
    mediaItems: [
      { type: 'image', url: 'https://i.imgur.com/TtLZYFw.png' },
      { type: 'image', url: 'https://i.imgur.com/Xb1Z5Oe.png' },
      { type: 'image', url: 'https://i.imgur.com/Xb1Z5Oe.png' },
    ],
  },
  {
    title: 'Uniform Detection',
    description: 'This system uses the YOLO algorithm to automate school uniform compliance detection at Bulacan State University. By applying computer vision to monitor student compliance through video analysis, it provides real-time feedback to administrators, promotes discipline, and reduces staff workload. The system ensures efficient and accurate enforcement of the school dress code.',
    image: 'https://i.imgur.com/Rw6kAio.png',
    mediaItems: [
      { type: 'video', url: 'https://i.imgur.com/3pdPUWS.mp4' },
    ],
  },
    {
    title: "Alicia's",
    description: "Alicia's is a food service that offers home-cooked meals made by mothers, bringing the warmth of homemade dishes to customers. The service focuses on providing freshly prepared, affordable, and comforting meals while supporting local mothers. Alicia's website is developed using a low-code platform, Odoo, allowing efficient management of orders, menus, and customer interactions.",
    image: 'https://i.imgur.com/xvHKn6u.png',
    mediaItems: [
      { type: 'image', url: 'https://i.imgur.com/Fa7DRI1.png' },
      { type: 'image', url: 'https://i.imgur.com/HBliqLv.png' },
      { type: 'image', url: 'https://i.imgur.com/qm4Bonm.png' },
    ],
  },
  // Add more projects...
];


function Projects({ onShowOtherProjects }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.realIndex);
  };

  const handleJoinClick = () => {
    setCurrentMediaIndex(0);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const nextMedia = () => {
    setCurrentMediaIndex((prev) => (prev + 1) % projectData[activeIndex].mediaItems.length);
  };

  const prevMedia = () => {
    setCurrentMediaIndex((prev) =>
      (prev - 1 + projectData[activeIndex].mediaItems.length) % projectData[activeIndex].mediaItems.length
    );
  };

  const currentProject = projectData[activeIndex];
  const currentMedia = currentProject.mediaItems[currentMediaIndex];

  return (
    <section id="projects" className="projects-section">
      <div className="ttl">
        <h1>Projects</h1>
      </div>
      <div className="content">
        <div className="info">
          <h2>{currentProject.title}</h2>
          <p>{currentProject.description}</p>
          <button className="btn" onClick={handleJoinClick}>More</button>
        </div>

        <Swiper
          effect={'cards'}
          grabCursor={true}
          initialSlide={0}
          speed={500}
          loop={true}
          modules={[EffectCards, Mousewheel]}
          mousewheel={{ invert: false }}
          onSlideChange={handleSlideChange}
          className="swiper"
        >
          {projectData.map((project, index) => (
            <SwiperSlide key={index}>
              <img src={project.image} alt={project.title} />
              <div className="overlay">
                <h2>{project.title}</h2>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div style={{ textAlign: 'center', marginTop: '30px' }}>
        <button className="btn" onClick={onShowOtherProjects}>Other Projects</button>
      </div>

      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="close-btn" onClick={closeModal}>X</button>
            {currentMedia.type === 'image' ? (
              <img src={currentMedia.url} alt="Project Media" />
            ) : (
              <video controls>
                <source src={currentMedia.url} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
            <div className="modal-nav">
              <button onClick={prevMedia} className="nav-arrow">&lt;</button>
              <button onClick={nextMedia} className="nav-arrow">&gt;</button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}


export default Projects;
